import React, { Component } from 'react'

import Demo from '../components/demo'
import Options from '../components/options'
import Methods from '../components/methods'

export default class App extends Component {
  render() {
    return (
      <div>
        <header className="header">
          <h1 className="header-title">React Popupbox</h1>
          <p className="header-describe">A simple lightbox component for react, inspired by <a href="https://github.com/jackmoore/colorbox">colorbox</a> and <a href="https://github.com/howtomakeaturn/React-Lightbox">React-Lightbox</a>.</p>
        </header>

        <h2>DEMO & USAGE</h2>

        <Demo />

        <h2>OPTIONS</h2>

        <Options />

        <h2>PUBLIC METHODS</h2>

        <Methods />

        <footer className="footer" >
          <div className="license">
            <span className="license-title">License: </span>
            <span className="license-type">MIT</span>
          </div>
          <div className="made-with-love">
            Made with ♥ by
            <a href="http://github.com/fraina">Faryn</a>
          </div>
          <div className="github-button">
            <a href="http://github.com/fraina/react-popupbox">View on Github</a>
          </div>
        </footer>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/App.js